export enum DishType {
    complex = 'complex',
    initial = 'initial',
}
